export enum PatientAllergyStatus
{
    UnActioned = 'UnActioned',
    Actioned = 'Actioned',
    Confirmed = 'Confirmed'
}